export const columns = [
	{ id: "name", label: "Назва складу", minWidth: 100 },
	{ id: "city", label: "Місто", minWidth: 100 },
	{ id: "alias1C", label: "1С-Назва", minWidth: 100 },
	{ id: "buttons", label: "", minWidth: 65 },
];

export const emptyWarehouse = {
	id: "new-warehouse-id",
	name: "",
	email: "",
	alias1C: "",
};
